// extracted by mini-css-extract-plugin
export default {"buildNumberBox":"Layout_buildNumberBox__+wN5V","freepikAttribution":"Layout_freepikAttribution__VHCci","freepikLink":"Layout_freepikLink__F+fkd"};